import { Map } from 'immutable';

import { SHOW_PROMPT_DIALOG, CLOSE_PROMPT_DIALOG } from './constants';

const initialState = Map({
  open: false,
  message: '',
  options: {
    yesLabel: 'Yes',
    noLable: 'No',
  },
});

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SHOW_PROMPT_DIALOG: {
      return state.set('open', true).set('message', action.message).set('options', action.options);
    }

    case CLOSE_PROMPT_DIALOG: {
      return initialState;
    }

    default:
      return state;
  }
}
